module.exports = __webpack_public_path__ + "img/Thevenin.9a228b63.jpg";